import PropTypes from 'prop-types';
import { Fragment, useContext } from 'react';
import { Route } from 'react-router-dom';
import { RuntimeContext } from '../../../common/RuntimeContext';
import AuthenticatedRoute from '../../shared/components/AuthenticatedRoute';
import { removeCookie } from '../../shared/utils/CookieUtils';
import NewAddOrEditCompany from './admin/NewAddOrEditCompany';
import ManageCollections from './admin/ManageCollections/ManageCollections';
import ViewAllCollectionsContainer from './admin/ViewAllCollections/ViewAllCollectionsContainer';
import ViewCollectionContainer from './admin/ViewCollectionContainer';
import AddOrEditCollectionV2 from './admin/AddOrEditCollectionV2';
import PushCollectionContainer from './admin/PushCollectionContainer';
import ManageLearningAssets from './admin/ManageLearningAssets/ManageLearningAssets';
import AddOrEditLearningAsset from './admin/AddOrEditLearningAsset';
import PreviewLearningAsset from './admin/PreviewLearningAsset';
import CopySection from './admin/CopySection/CopySection';
import AddOrEditBehavior from './admin/AddOrEditBehavior';
import AddOrEditDimension from './admin/AddOrEditDimension';
import ManageContentFramework from './admin/ManageContentFramework/ManageContentFramework';
import MediaLibrary from './admin/MediaLibrary/MediaLibrary';
import AddOrEditMediaLibraryFile from './admin/MediaLibrary/AddOrEditMediaLibraryFile';


import AdminLandingPage from './LandingPages/AdminLandingPage';

import '../../sass/admin.scss';

// Admin Routes Loaded Asynchronously via hocs/AsyncComponentLoader
const Admin = (props) => {
    const config = useContext(RuntimeContext);
  const { isVerbAdmin, isContentAuthor, loggedInUser, isAccountOwner } = props;

    const _logoutAdminRedirect = () => {
        window.localStorage.removeItem('id_token');
        window.localStorage.removeItem('ajs_user_id');
        removeCookie('ajs_user_id');
        window.location.replace(config.pathsWeb.clientUrl);
    };
   
    return (
        <Fragment>
            <Route path={'/admin/logoutredirect'} exact render={_logoutAdminRedirect} />
            <AuthenticatedRoute
                isAdminApp={true}
                path={'/admin/administration'}
                exact
                component={AdminLandingPage}
                allowedForContentReviewer={true}
                allowedForContentAuthor={true}
                allowedForContentAdmin={true}
                allowedForCompanyReportViewer={true}
                allowedForVerbReportViewer={true}
                allowedForCompanyAdmin={true}
                allowedForVerbAdmin={true}
                allowedForInstructionalAdmin={true}
                allowedForInstructionalContentAdmin={true}
                allowedForInstructionalReportViewer={true}
            />
            <AuthenticatedRoute
                isAdminApp={true}
                path={'/admin/editcompany/:id/:section?/:teamId?/:teamTab?'}
                exact
                component={NewAddOrEditCompany}
                allowedForCompanyAdmin={true}
                allowedForInstructionalAdmin={true}
            />
            {/* Admin Collections Routes - Content Admin Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/managecollections/:section'}
              exact
              component={ManageCollections}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/managecollections'}
              exact
              component={ManageCollections}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/viewcollections'}
              exact
              component={ViewAllCollectionsContainer}
              allowedForCompanyAdmin={true}
              allowedForContentAuthor={true}
              allowedForInstructionalAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/viewcollection/:id'}
              exact
              component={ViewCollectionContainer}
              allowedForCompanyAdmin={true}
              allowedForContentAuthor={true}
              allowedForInstructionalAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/viewcollection/:id/:section'}
              exact
              component={ViewCollectionContainer}
              allowedForCompanyAdmin={true}
              allowedForContentAuthor={true}
              allowedForInstructionalAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newcollection'}
              exact
              component={AddOrEditCollectionV2}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newcollection/:section'}
              exact
              component={AddOrEditCollectionV2}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editcollection/:id/:section'}
              exact
              component={AddOrEditCollectionV2}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editcollection/:id'}
              exact
              component={AddOrEditCollectionV2}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/pushcollection'}
              exact
              component={PushCollectionContainer}
              allowedForContentAdmin={true}
            />

                        {/* Admin Learning Assets Routes - Content Author Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/managelearningassets/:section'}
              exact
              component={ManageLearningAssets}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/managelearningassets'}
              exact
              component={ManageLearningAssets}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newlearningasset/:section'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editlearningasset/:id/:section'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editlearningasset/:id/:section/:sectionitemid'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newwelcomeasset/:section'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editwelcomeasset/:id/:section'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editwelcomeasset/:id/:section/:sectionitemid'}
              exact
              component={AddOrEditLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/previewlearningasset/:type/:id'}
              exact
              component={PreviewLearningAsset}
              allowedForContentAuthor={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/copysections'}
              exact
              component={CopySection}
              allowedForContentAuthor={true}
            />
            {/* Admin Behavior Routes - Content Admin Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editbehavior/:id'}
              exact
              component={AddOrEditBehavior}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newbehavior'}
              exact
              component={AddOrEditBehavior}
              allowedForContentAdmin={true}
            />
            {/* Admin Dimensions Route - Content Admin Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editdimension/:id'}
              exact
              component={AddOrEditDimension}
              allowedForContentAdmin={true}
            />
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newdimension'}
              exact
              component={AddOrEditDimension}
              allowedForContentAdmin={true}
            />

                        {/* Admin Media Library - Content Author Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/medialibrary'}
              exact
              component={MediaLibrary}
              allowedForContentAuthor={true}
              allowedForCompanyAdmin={true}
              componentProps={{
                isVerbAdmin,
                isContentAuthor,
                loggedInUser,
                isAccountOwner,
              }}
            />

            <AuthenticatedRoute
              isAdminApp={true}
              path={'/newmedialibraryfile'}
              exact
              component={AddOrEditMediaLibraryFile}
              allowedForContentAdmin={true}
              allowedForContentAuthor={true}
              allowedForCompanyAdmin={true}
              componentProps={{
                isVerbAdmin,
                isContentAuthor,
                loggedInUser,
                isAccountOwner,
              }}
            />

            <AuthenticatedRoute
              isAdminApp={true}
              path={'/editmedialibraryfile/:id'}
              exact
              component={AddOrEditMediaLibraryFile}
              allowedForContentAdmin={true}
              allowedForContentAuthor={true}
              allowedForCompanyAdmin={true}
              componentProps={{
                isVerbAdmin,
                isContentAuthor,
                loggedInUser,
                isAccountOwner,
              }}
            />

                        {/* Admin Manage Content Framework Route - Content Admin Permissions */}
            <AuthenticatedRoute
              isAdminApp={true}
              path={'/managecontentframework'}
              exact
              component={ManageContentFramework}
              allowedForContentAdmin={true}
            />
        </Fragment>
    );
}

Admin.propTypes = {
    isAuthenticated: PropTypes.bool,
    store: PropTypes.object,
    loggedInUserId: PropTypes.string,
    loggedInUserCompanyId: PropTypes.string,
    getProfile: PropTypes.func,
    getCompany: PropTypes.func,
    isVerbAdmin: PropTypes.bool,
    isAccountOwner: PropTypes.bool,
    isContentReviewer: PropTypes.bool,
    isContentAuthor: PropTypes.bool,
    isContentAdmin: PropTypes.bool,
    isCompanyReportViewer: PropTypes.bool,
    isVerbReportViewer: PropTypes.bool,
    isInstructionalAdmin: PropTypes.bool,
    isInstructionalContentAdmin: PropTypes.bool,
    isInstructionalReportViewer: PropTypes.bool,
    loggedInUser: PropTypes.object,
    logout: PropTypes.func,
    badges: PropTypes.object,
    userCompany: PropTypes.object,
    location: PropTypes.object,
    modal: PropTypes.object,
    adminChangeLanguage: PropTypes.func,
    history: PropTypes.object,
    updatePreviousLocation: PropTypes.func,
    getManyTeams: PropTypes.func,
    teamsUnsavedFlag: PropTypes.bool
};

export default Admin;
